import { Redirect, useLocalSearchParams } from "expo-router";
import { useCameraRouteParams } from "@src/hooks/useCameraRouteParams";

export interface RequireCameraKeyOptions {
  requireSiteId?: boolean;
}

/**
 * Higher-order guard for web screens that require camera route params.
 * Redirects to /overview when cameraKey (or siteId when required) is missing.
 */
export function RequireCameraKey({
  requireSiteId = true,
  children,
}: RequireCameraKeyOptions & {
  children: (params: { cameraKey: string; siteId: string }) => React.ReactNode;
}) {
  const params = useLocalSearchParams<{ tenantId?: string }>();
  const { cameraKey, siteId: effectiveSiteId } = useCameraRouteParams({
    requireSiteId,
    requireCameraKey: false,
  });

  const hasRequiredParams = !!cameraKey && (!requireSiteId || !!effectiveSiteId);

  if (!hasRequiredParams) {
    return params.tenantId ?
        <Redirect href={`/tenants/${params.tenantId}/overview` as never} />
      : <Redirect href="/overview" />;
  }

  return <>{children({ cameraKey, siteId: effectiveSiteId })}</>;
}
